import pageData from "../../data/camper-rental.json";
import LargeScreenComponent from "../LargeScreenComponent";
import {Col, Container, Row} from "reactstrap";
import Icon from "../Icon";
import SmallScreenComponent from "../SmallScreenComponent";
import React from "react";

interface USPProps {
    showTitle?: boolean
}

const USP = ({showTitle = false}: USPProps) => (
    <>
        <LargeScreenComponent>
            <section className="py-3">
                {showTitle &&
                <Row className="">
                    <Col xl="10" lg="10" className="mx-auto my-4">
                        <p className="subtitle text-primary">Een camper via Cottage Centre</p>
                        <h2>Waarom klanten voor Cottage Centre kiezen</h2>
                    </Col>
                </Row>
                }
                <Container fluid>
                    <Row className="bg-gray-100">
                        {pageData.topBlocks.blocks.map(block =>
                            <Col
                                key={block.title}
                                lg="3"
                                className="my-3"
                            >
                                <Row>
                                    <Col xs={2}>
                                        <div className="icon-rounded">
                                            <Icon
                                                icon={block.icon}
                                                className="text-primary w-2rem h-2rem"
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={10}>
                                        <div className="px-0 px-lg-3 pl-3">
                                            <h2 className="h5">{block.title}</h2>
                                            {/*<p className="text-muted dark">{block.content}</p>*/}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        )}
                    </Row>
                </Container>
            </section>
        </LargeScreenComponent>
        <SmallScreenComponent>
            <section className="py-2 pr-2">
                {showTitle &&
                <Row className="">
                    <Col xl="10" lg="10" className="mx-auto my-4">
                        <p className="subtitle text-primary">Een camper via Cottage Centre</p>
                        <h2>Waarom klanten voor Cottage Centre kiezen</h2>
                    </Col>
                </Row>
                }
                <Container fluid>
                    <Row className="">
                        {pageData.topBlocksMobile.blocks.map(block =>
                            <Col
                                key={block.title}
                                xs="3"
                                className="text-center p-0"
                            >
                                <Icon
                                    icon={block.icon}
                                    className="text-primary"
                                />
                                <div className="">
                                    <span className="mobile-usp ml-1 mr-1 mt-1">{block.title}</span>
                                </div>
                            </Col>
                        )}
                    </Row>
                </Container>
            </section>
        </SmallScreenComponent>
    </>
)

export default USP;
